// extracted by mini-css-extract-plugin
export var border = "_n-8";
export var brand = "_n-t";
export var button = "_n-l";
export var center = "_n-a";
export var centered = "_n-6";
export var closeButton = "_n-c";
export var disabledWrapper = "_n-m";
export var error = "_n-p";
export var extraLarge = "_n-4";
export var extraSmall = "_n-1";
export var fill = "_n-i";
export var footer = "_n-h";
export var footerAction = "_n-j";
export var footerButtons = "_n-k";
export var header = "_n-7";
export var headerWithClose = "_n-d";
export var icon = "_n-o";
export var info = "_n-s";
export var inline = "_n-9";
export var large = "_n-3";
export var main = "_n-e";
export var modal = "_n-0";
export var nearFull = "_n-5";
export var neutral = "_n-u";
export var noPadding = "_n-g";
export var none = "_n-v";
export var scrollable = "_n-f";
export var small = "_n-2";
export var success = "_n-r";
export var tight = "_n-n";
export var titleIcon = "_n-b";
export var warn = "_n-q";